import { BaseResponse } from './base.response';
import { OrderSummary } from '../models';

export class OrderSummariesResponse extends BaseResponse {

  public orderSummaries: OrderSummary[];

}
